export default __webpack_public_path__ + "static/media/ELOCAL.0d8e0c23.png";